<template>
  <modal-component
    :active="showModal"
    @cancel="close"
    :titleModal="'Eliminar webhook'"
    @hdlOnClick="changeWebhookStatus"
    :loader="loadingv2"
    textSave=""
    :isMessage="true"
    :withoutAction="true"
    :isConfirm="true"
  >
    <div class="delete-webhook-modal has-text-centered">
      <!-- Imagen de advertencia -->
      <div class="image-wrapper">
        <img
          src="../../assets/alert.png"
          alt="Advertencia"
          class="warning-image"
        />
      </div>

      <p class="title is-6 mt-3">
        ¿Estás seguro de que deseas eliminar este webhook?
      </p>

      <p class="subtitle is-7 has-text-grey">
        Esta acción lo desactivará y ya no recibirá eventos, <br />
        pero podrás reactivarlo más adelante.
      </p>
    </div>
    <template slot="footer">
        <div class="columns is-multiline">
          <div class="column is-6">
            <button
              class="button btn-cancel"
              :disabled="loading"
              @click="close"
            >
              <span>Cancelar</span>
            </button>
          </div>
          <div class="column is-6 is-flex is-justify-content-flex-end">
            <button
              :class="`button is-button-danger ${ loading ? 'is-loading' : ''} right`"
              :disabled="loading"
              @click="changeWebhookStatus"
            >
              <span>Eliminar</span>
            </button>
          </div>
        </div>
      </template>
  </modal-component>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'DeleteWebhookModal',
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  props: {
    showModal: { type: Boolean, default: false },
    close: { type: Function, default: () => {} },
    webhook: { type: Object },
    getWebhooks: { type: Function }
  },
  data () {
    return {
      loadingv2: false
    }
  },
  methods: {
    ...mapActions(['deleteWebhook']),
    async changeWebhookStatus () {
      this.loadingv2 = true
      const result = await this.deleteWebhook({ webhookId: this.webhook.id })
      if (result && result.success) {
        this.getWebhooks()
        this.close()
      }
      this.loadingv2 = false
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-webhook-modal {
  padding: 0.5rem 1rem;
}

.image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffecec;
  border-radius: 50%;
  width: 90px;
  height: 90px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.warning-image {
  width: 45px;
  height: 45px;
}

.title {
  font-weight: 600;
  color: #1f1f1f;
}

.subtitle {
  color: #7a7a7a;
  font-size: 0.9rem;
  margin-top: 0.25rem;
}
.is-button-danger {
  background-color: #ff756d;
  border-color: #ff756d;
  color: #ffffff;
}
.columns {
  width: 100%;
}
</style>
